
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/web/get-started/[[...params]]",
      function () {
        return require("private-next-pages/web/get-started/[[...params]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/web/get-started/[[...params]]"])
      });
    }
  